import { mergeMap } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { Types, Creators } from '../ducks/goals';
import { Api } from '../../api';

// eslint-disable-next-line
export const createPlan = action$ =>
  action$.pipe(
    ofType(Types.CREATE_PLAN_REQUESTED),
    mergeMap((({ values }) => Api.postPlan(values)
      .then(res => Creators.createPlanSuccess(res))
      .catch(err => Creators.createPlanError(err))
    )),
  );

const epicList = [
  createPlan,
];

export default epicList;
